module.exports = __webpack_public_path__ + "img/marjasuvannon-lomamajat.064d3a00.jpg";